import { dpActions } from '../../../Reducers/DPReducer/dpReducer';

// ✅ Re-export ONLY what actually exists
export const {
  initDP,
  addProduct,
  updateProductQty,
  removeProduct,
  selectShipToParty,
  setShipToPartyDetails,
  moveProductsToShipToParty,
  setDPDetails,
  setLoading,
  setError,
  hydrateDpFromOrder,
  resetDP,
  
} = dpActions;

/* ---------------- LEGACY COMPATIBILITY ---------------- */

export const addProductToCart = (product, shipToPartyId) =>
  addProduct(product, shipToPartyId);

export const removeProductFromCart = (productId) =>
  removeProduct(productId);

export const hydrateDpFromOrderAction = (payload) => 
  hydrateDpFromOrder(payload);

// Cart clear = full DP reset
export const clearCart = () => resetDP();

/* ---------------- CATEGORY (UNCHANGED) ---------------- */

export const setSelectedCategory = (category) => ({
  type: 'SET_SELECTED_CATEGORY',
  payload: category
});

export const setSelectedFormType = (formType) => ({
  type: 'SET_SELECTED_FORM_TYPE',
  payload: formType
});

export const setSkuCategories = (categories) => ({
  type: 'SET_SKU_CATEGORIES',
  payload: categories
});
export const resetSelectedShipToParty = () => ({
  type: 'RESET_SELECTED_SHIP_TO_PARTY'
});
export const removeShipToParty = (id) => ({
  type: 'REMOVE_SHIP_TO_PARTY',
  payload: {id}
});

export const setDpRouteSource = (source) => ({
  type: 'SET_DP_ROUTE_SOURCE',
  payload: source,
});

export const resetDpRouteSource = () => ({
  type: 'RESET_DP_ROUTE_SOURCE',
});